import { Component, Inject, OnInit, Optional } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FinanceService } from 'src/app/_services/finance.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BusinessFinanceClientComponent } from '../business-finance-client/business-finance-client.component';
@Component({
  selector: 'app-add-client-finance',
  templateUrl: './add-client-finance.component.html',
  styleUrls: ['./add-client-finance.component.css']
})
export class AddClientFinanceComponent implements OnInit {

  isEdit:boolean =false;
  editId:number=null;

  addFinanceForm = new UntypedFormGroup({
    username: new UntypedFormControl('', Validators.compose([Validators.required])),
    address: new UntypedFormControl('', Validators.compose([Validators.required])),
    country: new UntypedFormControl('', Validators.compose([Validators.required])),
    post: new UntypedFormControl('', Validators.compose([Validators.required])),  
    pib: new UntypedFormControl('', Validators.compose([Validators.required])),
    indetificationNumber: new UntypedFormControl('', Validators.compose([Validators.required])),
    //password je city
    password: new UntypedFormControl('',),
    customer1: new UntypedFormControl(''),
    customer2: new UntypedFormControl(''),
    startState: new UntypedFormControl('',),
    firstName: new UntypedFormControl('',),
    email: new UntypedFormControl('',),
    name: new UntypedFormControl('',),
    phone: new UntypedFormControl('',),
    note: new UntypedFormControl('',),
    mobilePhone: new UntypedFormControl('',),
    fax: new UntypedFormControl('',),
    createdAt: new UntypedFormControl(new Date(),),
    sendEmail: new UntypedFormControl(false),


  });

  emailNotification = new UntypedFormGroup({
    dayBeforePayment: new UntypedFormControl(''),
    datAfterPayment: new UntypedFormControl(''),
    warningBeforeSuspension: new UntypedFormControl('')
  })

  showEmailSettingsReport = false;
  constructor(private financeService:FinanceService,private router: Router,
    private notify: NotificationService,    @Optional() public dialogRef: MatDialogRef<BusinessFinanceClientComponent>, 
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any ) {
      
  }
   
 
  ngOnInit(): void {
    
 
   if(this.data != null){
    this.patchValues(this.data);
    this.isEdit =true;
    this.editId = this.data.clientFinance.id;
   }
    
    
  }

  patchValues(data) {
    
    this.addFinanceForm.patchValue(data['clientFinance']);
  }
  onCloseClick(): void {
    this.dialogRef.close();
    this.router.navigate(['/finance/business/client']);
  }


 

  onSubmit() {
    if (this.addFinanceForm.invalid) {
      this.notify.warning(`Forma nije isprovno popunjena`);
      this.addFinanceForm.markAllAsTouched();
      return;
    }
      
      const formData = this.addFinanceForm.value;
      let dayP= new Date(formData.createdAt);
      dayP =new Date(dayP.getTime() - (dayP.getTimezoneOffset() * 60000));
      formData['createdAt'] = dayP;
      // console.log(formData);
      // return
      if(this.isEdit){
        this.financeService.editUser( formData,this.editId).subscribe(
          (response) => {
            // console.log('Uspešno poslato na server', response);
            this.notify.success(`Podaci su uspešno ažurirani`);
          },
          (error) => {
            this.notify.warning(error.error);
            
          }
        );
        return;
      }
    
      this.financeService.addUser( formData).subscribe(
        (response) => {
          // console.log('Uspešno poslato na server', response);
          this.notify.success(`Stranka je uspešno sačuvana`);
        },
        (error) => {
          this.notify.warning(error.error);
          
        }
      );
      
     
    }
    onSubmitNew() {
      if (this.addFinanceForm.invalid) {
        this.notify.warning(`Forma nije isprovno popunjena`);
        this.addFinanceForm.markAllAsTouched();
        return;
      }
          
        const formData = this.addFinanceForm.value;
        let dayP= new Date(formData.createdAt);
        dayP =new Date(dayP.getTime() - (dayP.getTimezoneOffset() * 60000));
        formData['createdAt'] = dayP;
        //console.log(formData);
        if(this.isEdit){
          this.financeService.editUser( formData,this.editId).subscribe(
            (response) => {
              console.log('Uspešno poslato na server', response);
              this.notify.warning(`Podaci su uspešno ažurirani`);
            },
            (error) => {
              this.notify.warning(error.error);
              
            }
          );
          return;
        }
        this.financeService.addUser( formData).subscribe(
          (response) => {
            console.log('Uspešno poslato na server', response);
            this.notify.warning(`Stranka je uspešno sačuvana`);
          },
          (error) => {
            this.notify.warning(error.error);
          }
        );
        this.addFinanceForm.reset({ });
      

       
        
       
      }
      onCustomer1Change(checkBox1:boolean) {
       
        if (checkBox1) {
          
          this.addFinanceForm.get('customer1').setValue('Kupac');
        } else {
          
          this.addFinanceForm.get('customer1').setValue('');
        }
        
        
      }
      onCustomer2Change(checkBox2:boolean) {
       
        if (checkBox2) {
          
          this.addFinanceForm.get('customer2').setValue('Dobavljač');
        } else {
          
          this.addFinanceForm.get('customer2').setValue('');
        }
        
        
      }

      showEmailSettings(){
        this.notify.warning("Kartica u izradi");
        // this.showEmailSettingsReport = true;
      }

      back() {
        this.showEmailSettingsReport = false;
      }
      onSendEmialChange(checkBox1:boolean) {
       
        if (checkBox1) {
          
          this.addFinanceForm.get('sendEmail').setValue(checkBox1);
        } else {
          
          this.addFinanceForm.get('sendEmail').setValue(checkBox1);
        }
        
        
      }
     
  }

  
 
  
   

